import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import { IPermission } from '../../../../../../../../hooks/api/permissions';
import useDialogContext from '../../../../../../../../hooks/dialog/useDialogContext';

type DeletePermissionButtonnProps = {
  permission: IPermission;
};

const DeletePermissionButton = ({ permission }: DeletePermissionButtonnProps) => {
  const { t } = useTranslation();
  const { openDialog } = useDialogContext();

  return (
    <Button
      label={t('productDetailsPage.tabs.permissionsTab.buttons.delete')}
      onClick={() => {
        return openDialog('delete-permission-dialog', {
          permission,
        });
      }}
    />
  );
};

export default DeletePermissionButton;
